import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const LinkIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4144 5.5854C16.4111 3.58221 13.1633 3.58221 11.1601 5.5854L10.0292 6.71635C9.58752 7.15801 9.58752 7.8741 10.0292 8.31575C10.4709 8.75741 11.1869 8.75741 11.6286 8.31575L12.7596 7.1848C13.8794 6.06494 15.6951 6.06494 16.8149 7.1848C17.9347 8.30466 17.9347 10.1203 16.8149 11.2402L15.6839 12.3711C15.2423 12.8128 15.2423 13.5289 15.6839 13.9705C16.1257 14.4122 16.8417 14.4122 17.2834 13.9705L18.4144 12.8396C20.4175 10.8364 20.4175 7.58858 18.4144 5.5854ZM14.4963 9.50354C14.938 9.94521 14.938 10.6613 14.4963 11.103L11.1034 14.4958C10.6618 14.9375 9.9457 14.9375 9.50403 14.4958C9.06237 14.0541 9.06237 13.3381 9.50403 12.8964L12.8969 9.50354C13.3386 9.06188 14.0546 9.06188 14.4963 9.50354ZM8.31624 10.0288C8.75791 10.4705 8.75791 11.1866 8.31624 11.6282L7.18529 12.7592C6.06543 13.8791 6.06543 15.6947 7.18529 16.8146C8.30515 17.9345 10.1208 17.9345 11.2406 16.8146L12.3716 15.6836C12.8133 15.2419 13.5293 15.2419 13.971 15.6836C14.4127 16.1253 14.4127 16.8414 13.971 17.283L12.8401 18.414C10.8369 20.4171 7.58906 20.4171 5.58589 18.414C3.5827 16.4107 3.5827 13.163 5.58589 11.1598L6.71684 10.0288C7.1585 9.58718 7.87458 9.58718 8.31624 10.0288Z"
      fill="currentColor"
    />
  </svg>
);
